/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  FursBusinessPremise,
  FursPremiseSuccessResponse,
  RegisterFursMovablePremiseBody,
  RegisterFursRealEstatePremiseBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve all registered business premises for the entity. Each premise represents a physical location or movable unit where invoices are issued.
 * @summary List all business premises
 */
export type listFursBusinessPremisesResponse200 = {
  data: FursBusinessPremise[]
  status: 200
}

export type listFursBusinessPremisesResponse400 = {
  data: Error
  status: 400
}

export type listFursBusinessPremisesResponse401 = {
  data: Error
  status: 401
}

export type listFursBusinessPremisesResponse403 = {
  data: Error
  status: 403
}

export type listFursBusinessPremisesResponse404 = {
  data: Error
  status: 404
}

export type listFursBusinessPremisesResponse500 = {
  data: Error
  status: 500
}

export type listFursBusinessPremisesResponseSuccess = (listFursBusinessPremisesResponse200) & {
  headers: Headers;
};
export type listFursBusinessPremisesResponseError = (listFursBusinessPremisesResponse400 | listFursBusinessPremisesResponse401 | listFursBusinessPremisesResponse403 | listFursBusinessPremisesResponse404 | listFursBusinessPremisesResponse500) & {
  headers: Headers;
};

export type listFursBusinessPremisesResponse = (listFursBusinessPremisesResponseSuccess | listFursBusinessPremisesResponseError)

export const getListFursBusinessPremisesUrl = () => {


  

  return `/fiscalization/furs/premises`
}

export const listFursBusinessPremises = async ( options?: RequestInit): Promise<listFursBusinessPremisesResponse> => {
  
  return customFetch<listFursBusinessPremisesResponse>(getListFursBusinessPremisesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve details of a specific business premise by ID, including its electronic devices.
 * @summary Get a business premise
 */
export type getFursBusinessPremiseResponse200 = {
  data: FursBusinessPremise
  status: 200
}

export type getFursBusinessPremiseResponse400 = {
  data: Error
  status: 400
}

export type getFursBusinessPremiseResponse401 = {
  data: Error
  status: 401
}

export type getFursBusinessPremiseResponse403 = {
  data: Error
  status: 403
}

export type getFursBusinessPremiseResponse404 = {
  data: Error
  status: 404
}

export type getFursBusinessPremiseResponse500 = {
  data: Error
  status: 500
}

export type getFursBusinessPremiseResponseSuccess = (getFursBusinessPremiseResponse200) & {
  headers: Headers;
};
export type getFursBusinessPremiseResponseError = (getFursBusinessPremiseResponse400 | getFursBusinessPremiseResponse401 | getFursBusinessPremiseResponse403 | getFursBusinessPremiseResponse404 | getFursBusinessPremiseResponse500) & {
  headers: Headers;
};

export type getFursBusinessPremiseResponse = (getFursBusinessPremiseResponseSuccess | getFursBusinessPremiseResponseError)

export const getGetFursBusinessPremiseUrl = (id: string,) => {


  

  return `/fiscalization/furs/premises/${id}`
}

export const getFursBusinessPremise = async (id: string, options?: RequestInit): Promise<getFursBusinessPremiseResponse> => {
  
  return customFetch<getFursBusinessPremiseResponse>(getGetFursBusinessPremiseUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Register a real estate (physical location) business premise with FURS (Slovenia). Required before fiscalizing invoices from this location.
 * @summary Register real estate premise
 */
export type registerFursRealEstatePremiseResponse200 = {
  data: FursPremiseSuccessResponse
  status: 200
}

export type registerFursRealEstatePremiseResponse400 = {
  data: Error
  status: 400
}

export type registerFursRealEstatePremiseResponse401 = {
  data: Error
  status: 401
}

export type registerFursRealEstatePremiseResponse403 = {
  data: Error
  status: 403
}

export type registerFursRealEstatePremiseResponse404 = {
  data: Error
  status: 404
}

export type registerFursRealEstatePremiseResponse422 = {
  data: ValidationError
  status: 422
}

export type registerFursRealEstatePremiseResponse500 = {
  data: Error
  status: 500
}

export type registerFursRealEstatePremiseResponseSuccess = (registerFursRealEstatePremiseResponse200) & {
  headers: Headers;
};
export type registerFursRealEstatePremiseResponseError = (registerFursRealEstatePremiseResponse400 | registerFursRealEstatePremiseResponse401 | registerFursRealEstatePremiseResponse403 | registerFursRealEstatePremiseResponse404 | registerFursRealEstatePremiseResponse422 | registerFursRealEstatePremiseResponse500) & {
  headers: Headers;
};

export type registerFursRealEstatePremiseResponse = (registerFursRealEstatePremiseResponseSuccess | registerFursRealEstatePremiseResponseError)

export const getRegisterFursRealEstatePremiseUrl = () => {


  

  return `/fiscalization/furs/premises/real-estate`
}

export const registerFursRealEstatePremise = async (registerFursRealEstatePremiseBody: RegisterFursRealEstatePremiseBody, options?: RequestInit): Promise<registerFursRealEstatePremiseResponse> => {
  
  return customFetch<registerFursRealEstatePremiseResponse>(getRegisterFursRealEstatePremiseUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerFursRealEstatePremiseBody,)
  }
);}
  

/**
 * Register a movable business premise (vehicle, market stall, vending machine) with FURS (Slovenia). Required before fiscalizing invoices from this premise.
 * @summary Register movable premise
 */
export type registerFursMovablePremiseResponse200 = {
  data: FursPremiseSuccessResponse
  status: 200
}

export type registerFursMovablePremiseResponse400 = {
  data: Error
  status: 400
}

export type registerFursMovablePremiseResponse401 = {
  data: Error
  status: 401
}

export type registerFursMovablePremiseResponse403 = {
  data: Error
  status: 403
}

export type registerFursMovablePremiseResponse404 = {
  data: Error
  status: 404
}

export type registerFursMovablePremiseResponse422 = {
  data: ValidationError
  status: 422
}

export type registerFursMovablePremiseResponse500 = {
  data: Error
  status: 500
}

export type registerFursMovablePremiseResponseSuccess = (registerFursMovablePremiseResponse200) & {
  headers: Headers;
};
export type registerFursMovablePremiseResponseError = (registerFursMovablePremiseResponse400 | registerFursMovablePremiseResponse401 | registerFursMovablePremiseResponse403 | registerFursMovablePremiseResponse404 | registerFursMovablePremiseResponse422 | registerFursMovablePremiseResponse500) & {
  headers: Headers;
};

export type registerFursMovablePremiseResponse = (registerFursMovablePremiseResponseSuccess | registerFursMovablePremiseResponseError)

export const getRegisterFursMovablePremiseUrl = () => {


  

  return `/fiscalization/furs/premises/movable`
}

export const registerFursMovablePremise = async (registerFursMovablePremiseBody: RegisterFursMovablePremiseBody, options?: RequestInit): Promise<registerFursMovablePremiseResponse> => {
  
  return customFetch<registerFursMovablePremiseResponse>(getRegisterFursMovablePremiseUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerFursMovablePremiseBody,)
  }
);}
  

/**
 * Close a previously registered business premise with FURS. This should be done when a business location is permanently closed.
 * @summary Close business premise
 */
export type closeFursBusinessPremiseResponse200 = {
  data: FursPremiseSuccessResponse
  status: 200
}

export type closeFursBusinessPremiseResponse400 = {
  data: Error
  status: 400
}

export type closeFursBusinessPremiseResponse401 = {
  data: Error
  status: 401
}

export type closeFursBusinessPremiseResponse403 = {
  data: Error
  status: 403
}

export type closeFursBusinessPremiseResponse404 = {
  data: Error
  status: 404
}

export type closeFursBusinessPremiseResponse422 = {
  data: ValidationError
  status: 422
}

export type closeFursBusinessPremiseResponse500 = {
  data: Error
  status: 500
}

export type closeFursBusinessPremiseResponseSuccess = (closeFursBusinessPremiseResponse200) & {
  headers: Headers;
};
export type closeFursBusinessPremiseResponseError = (closeFursBusinessPremiseResponse400 | closeFursBusinessPremiseResponse401 | closeFursBusinessPremiseResponse403 | closeFursBusinessPremiseResponse404 | closeFursBusinessPremiseResponse422 | closeFursBusinessPremiseResponse500) & {
  headers: Headers;
};

export type closeFursBusinessPremiseResponse = (closeFursBusinessPremiseResponseSuccess | closeFursBusinessPremiseResponseError)

export const getCloseFursBusinessPremiseUrl = (id: string,) => {


  

  return `/fiscalization/furs/premises/${id}/close`
}

export const closeFursBusinessPremise = async (id: string, options?: RequestInit): Promise<closeFursBusinessPremiseResponse> => {
  
  return customFetch<closeFursBusinessPremiseResponse>(getCloseFursBusinessPremiseUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

